import { Fragment, type FC } from 'react';
import { PayinNewOrdersCount } from '~/features/payin';
import { PayoutNewOrdersCount } from '~/features/payout';
import { routes } from '~/shared/constants/routes';
import { type NavbarTab } from './types';
import { Tab, TabMenu } from './components';

interface TabsProps {
    tabs: NavbarTab[];
    onClose?: VoidFunction;
    compact?: boolean;
}

export const Tabs: FC<TabsProps> = ({ tabs, onClose, compact = false }) => {
    const renderTab = (tab: NavbarTab) => {
        if (tab.children?.length) {
            return (
                <TabMenu
                    tab={tab}
                    onClose={onClose}
                    compact={compact}
                />
            );
        }

        return (
            <Tab
                tab={tab}
                onClose={onClose}
                compact={compact}
            />
        );
    };

    return tabs.map((tab) => {
        if (tab.to === routes.payin) {
            return <PayinNewOrdersCount key={tab.to}>{renderTab(tab)}</PayinNewOrdersCount>;
        }

        if (tab.to === routes.payout) {
            return <PayoutNewOrdersCount key={tab.to}>{renderTab(tab)}</PayoutNewOrdersCount>;
        }

        return <Fragment key={tab.to}>{renderTab(tab)}</Fragment>;
    });
};
